import React from 'react';
import { DropdownTooltipText } from '@instinet-analytics/semantic-ui-components';
import chartPreview from './obvTilePreview.png';

export const obvTileDescription: DropdownTooltipText = {
    body: (
        <>
            <div>
                The OBV (on-balance volume) chart captures crowd sentiment,
                since it is thought that a dramatic change in trading volume
                often reflects the market’s attitude towards a particular
                security.
            </div>
        </>
    ),
    minPreviewHeight: 180,
    previews: [
        {
            title: 'Chart',
            src: chartPreview,
            altText: 'obv-capsule-chart-preview',
        },
    ],
};
